import type { Command } from 'common/Prose/Commands'

export const JoinListsMetaKey = 'joinLists'

export const joinListsFromFirstListItem: Command = (
  { doc, schema, selection: { $from, $to, empty }, tr },
  dispatch,
) => {
  if (!empty) return false

  // NOTE: If we are not on a list item (either on a text position or a gap cursor)
  if ($from.node().type !== schema.nodes.list_item && $from.node($from.depth - 1)?.type !== schema.nodes.list_item)
    return false

  // NOTE: If we are not on the first position
  if ($from.pos !== $from.start()) return false

  const listItem = $from.node().type === schema.nodes.list_item ? $from.node() : $from.node($from.depth - 1)
  const $listBefore = doc.resolve(
    $from.node().type === schema.nodes.list_item ? $from.before($from.depth - 1) : $from.before($from.depth - 2),
  )
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  if ($listBefore.nodeAfter!.firstChild !== listItem) return false

  // NOTE: if the lists are incompatible don't join
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  if ($listBefore.nodeBefore?.type !== $listBefore.nodeAfter!.type) return false

  tr.join($listBefore.pos)
  dispatch?.(tr)

  return true
}
